import React from "react";
import { useLocation } from "react-router-dom";
import { LinkButton, PageHeader, PrimaryButton } from "cstar-react-primitives";

import { useFormatMessage } from "../../../intl/intlHooks";
import { loginUrl } from "../../../user/utils";
import { toQueryString } from "../../../utils/sharedFunctions";
import { orderSummarySSOCheckout } from "../orderSummaryMessages";
import { cashbotName } from "../../core/coreUtils";

const SingleSignOn = () => {
    const formatMessage = useFormatMessage();
    const location = useLocation();
    const initUrl = `${loginUrl}${toQueryString({ redirect_url: location.pathname })}`;
    return (
        <>
            <PageHeader heading={formatMessage(orderSummarySSOCheckout.checkoutPageHeader)} />

            <div className="sso-card">
                <p className="sso-card__text">{formatMessage(orderSummarySSOCheckout.loginContainerText)}</p>

                <div className="sso-card__actions">
                    <div className="sso-card__action-item">
                        <LinkButton onClick={() => { window.location = initUrl }}>
                            {formatMessage(orderSummarySSOCheckout.createAccountBtn)}
                        </LinkButton>
                    </div>

                    <div className="sso-card__action-item">
                        <PrimaryButton
                            isSmall
                            btnText={formatMessage(orderSummarySSOCheckout.signInBtn)}
                            onClick={() => { window.location = initUrl }}
                            cashbotName={cashbotName}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default SingleSignOn;
